module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "th-sorter",
    class: [_vm.sortProp, {
      'active': _vm.activeSortKey === _vm.sortProp
    }],
    on: {
      "click": _vm.sortBy
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.title) + "\n  "), _c('span', {
    staticClass: "icon-menu-open"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75af5a47!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursAllUsersTheadTh.vue
// module id = 1680
// module chunks = 1